import React, { useState } from 'react'
import DownIcon from 'assets/images/rectangle/down1.svg'
import UpIcon from 'assets/images/rectangle/up1.svg'
import useSetDeleteSettlement from '../hooks/useSetDeleteSettlement'
import { useParams } from 'react-router-dom'
interface iItemProps {
    item: IAdminSettlementResult
    refetch: () => void
    setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>
    setSelectedItem: React.Dispatch<
        React.SetStateAction<IAdminSettlementResult | undefined>
    >
}

export default function Item({
    item,
    refetch,
    setIsOpenModal,
    setSelectedItem,
}: iItemProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const { moneyPool } = useParams()
    const { mutate } = useSetDeleteSettlement(refetch)
    return (
        <>
            <div
                className=" py-2 px-2 bg-white my-2 mx-2 rounded-md shadow-[4px_4px_25px__rgba(0,0,0,0.1)]"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className=" flex justify-between">
                    <div>
                        {item.requesting_user.member.first_name +
                            ' ' +
                            item.requesting_user.member.last_name}
                    </div>
                    <div className=" flex">
                        <p className=" text-sm text-gray-4 bg-error-4 px-2 py-0.5 rounded-full mx-2">
                            {item.status === null
                                ? 'در حال بررسی'
                                : item.status === 'rjc'
                                ? 'رد شده'
                                : 'پذیرفته شده'}
                        </p>
                        {item.status === null && (
                            <img
                                src={isOpen ? UpIcon : DownIcon}
                                alt="down-up"
                            />
                        )}
                    </div>
                </div>
                <p className=" text-sm">{item.discription}</p>
                {isOpen && item.status === null && (
                    <div className=" flex justify-between my-3">
                        <button
                            onClick={() => {
                                setSelectedItem(item)
                                setIsOpenModal(true)
                            }}
                            className="w-full border-1 border-green-1 rounded-lg text-green-1 bg-green-main py-2 ml-1"
                        >
                            قبول
                        </button>
                        <button
                            className=" border-1 border-red-1 text-red-1 rounded-lg py-2 w-full mr-1"
                            onClick={() => {
                                const payload: getAdminSettlementsPostPayload =
                                    {
                                        moneyPool: moneyPool,
                                        id: item.id,
                                    }
                                mutate(payload)
                            }}
                        >
                            رد
                        </button>
                    </div>
                )}
            </div>
        </>
    )
}
